import React from "react";

export function ContentWrapper({ children }) {
  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="setting-setion">
          <div className="membershipSectionTitle">Sync Settings</div>
          <div className="wallet-edit-block">
            <div className="membershipSectionContent p20">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
